import { render, staticRenderFns } from "./ColorModuleWelcomeModal.vue?vue&type=template&id=1cffaaf8&scoped=true"
import script from "./ColorModuleWelcomeModal.vue?vue&type=script&lang=ts"
export * from "./ColorModuleWelcomeModal.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleWelcomeModal.vue?vue&type=style&index=0&id=1cffaaf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cffaaf8",
  null
  
)

export default component.exports